import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { ReactComponent as CheckFilledRoundIcon } from 'assets/ss-icons/check-filled-round.svg';

/**
 * @param {object} props
 * @param {import('utils/types').Size} props.size
 * @param {boolean} props.isSelected
 * @param {boolean} props.isDisabled
 * @param {() => void} props.onClick
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function Chip({
  size = 'md',
  isSelected = false,
  isDisabled = false,
  onClick = () => {},
  className = '',
  children = null
}) {
  return (
    <div
      data-size={size}
      data-selected={isSelected}
      data-disabled={isDisabled}
      onClick={onClick}
      className={cn(styles.container, className)}
    >
      <div className={styles.content}>{children}</div>
      {isSelected && <CheckFilledRoundIcon className={styles.checkIcon} />}
    </div>
  );
}
